import React, { createContext, useState, useMemo, useCallback } from "react";

export const ClientContext = createContext();

export const ClientProvider = ({ children }) => {
  const [isListChanged, setIsListChanged] = useState(false);

  const [isArchivedListChanged, setIsArchivedListChanged] = useState(false);

  const refreshList = useCallback(
    () => setIsListChanged(!isListChanged),
    [isListChanged]
  );

  const refreshArchivedList = useCallback(
    () => setIsArchivedListChanged(!isArchivedListChanged),
    [isArchivedListChanged]
  );

  const listValue = useMemo(
    () => ({ isListChanged, refreshList }),
    [isListChanged, refreshList]
  );

  const archivedListValue = useMemo(
    () => ({ isArchivedListChanged, refreshArchivedList }),
    [isArchivedListChanged, refreshArchivedList]
  );



  return (
    <ClientContext.Provider value={{ ...archivedListValue, ...listValue }}>
      {children}
    </ClientContext.Provider>
  );
};
